import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetSupplierProductsQueryResponse, GetSupplierProductsPathParams, GetSupplierProductsQueryParams, GetSupplierProducts400, GetSupplierProducts500 } from "../types/GetSupplierProducts";

export const getSupplierProductsQueryKey = (supplierId: GetSupplierProductsPathParams["supplierId"], params: GetSupplierProductsQueryParams) =>     [{url:`/api/catalog/suppliers/${supplierId}/products`,params:{supplierId:supplierId}},...(params ? [params] : [])] as const;
      export function getSupplierProductsQueryOptions <TData = GetSupplierProductsQueryResponse, TError = GetSupplierProducts400 | GetSupplierProducts500>(supplierId: GetSupplierProductsPathParams["supplierId"], params: GetSupplierProductsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getSupplierProductsQueryKey(supplierId, params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/catalog/suppliers/${supplierId}/products`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение всех товаров поставщика
 * @link /api/catalog/suppliers/:supplierId/products
 */

export function useGetSupplierProducts <TData = GetSupplierProductsQueryResponse, TError = GetSupplierProducts400 | GetSupplierProducts500>(supplierId: GetSupplierProductsPathParams["supplierId"], params: GetSupplierProductsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSupplierProductsQueryKey(supplierId, params);

  const query = useQuery<TData, TError>({
    ...getSupplierProductsQueryOptions<TData, TError>(supplierId, params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
